import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SearchTitleGraphqlFragment = {
	__typename?: 'PopularTitlesEdge';
	cursor: string;
	node:
		| {
				__typename?: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				content: {
					__typename?: 'MovieContent';
					title: string;
					fullPath: string;
					originalReleaseYear?: number | null;
					posterUrl?: string | null;
					genres: Array<{ __typename?: 'Genre'; shortName: string }>;
					scoring: {
						__typename?: 'Scoring';
						imdbScore?: number | null;
						imdbVotes?: number | null;
						tmdbScore?: number | null;
						tmdbPopularity?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
					};
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
				};
				watchNowOffer?: {
					__typename?: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
				} | null;
				offers: Array<{
					__typename?: 'Offer';
					monetizationType: Types.MonetizationType;
					presentationType: Types.PresentationType;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					id: string;
					package: { __typename?: 'Package'; id: string; packageId: number };
				}>;
		  }
		| {
				__typename?: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				content: {
					__typename?: 'ShowContent';
					title: string;
					fullPath: string;
					originalReleaseYear?: number | null;
					posterUrl?: string | null;
					genres: Array<{ __typename?: 'Genre'; shortName: string }>;
					scoring: {
						__typename?: 'Scoring';
						imdbScore?: number | null;
						imdbVotes?: number | null;
						tmdbScore?: number | null;
						tmdbPopularity?: number | null;
						tomatoMeter?: number | null;
						certifiedFresh?: boolean | null;
					};
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
				};
				watchNowOffer?: {
					__typename?: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
				} | null;
				offers: Array<{
					__typename?: 'Offer';
					monetizationType: Types.MonetizationType;
					presentationType: Types.PresentationType;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					id: string;
					package: { __typename?: 'Package'; id: string; packageId: number };
				}>;
		  };
};

export const SearchTitleGraphqlFragmentDoc = gql`
	fragment SearchTitleGraphql on PopularTitlesEdge {
		cursor
		node {
			id
			objectId
			objectType
			content(country: $country, language: $language) {
				title
				fullPath
				originalReleaseYear
				genres {
					shortName
				}
				scoring {
					imdbScore
					imdbVotes
					tmdbScore
					tmdbPopularity
					tomatoMeter
					certifiedFresh
				}
				posterUrl(profile: $profile, format: $format)
				backdrops(profile: $backdropProfile, format: $format) {
					backdropUrl
				}
				upcomingReleases(releaseTypes: [DIGITAL]) {
					releaseDate
				}
			}
			watchNowOffer(country: $country, platform: WEB) {
				id
				standardWebURL
				preAffiliatedStandardWebURL
			}
			offers(country: $country, platform: WEB, filter: { preAffiliate: true }) {
				monetizationType
				presentationType
				standardWebURL
				preAffiliatedStandardWebURL
				package {
					id
					packageId
				}
				id
			}
		}
	}
`;
